<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
     class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row m-0 p-2 background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto">
            <app-spinner [loading]="loading"></app-spinner>
            @if (!loading) {
                <div class="fs-main text-center color-white">Delete {{ animals.length }} animal(s)</div>
            }
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="mb-3">
            <app-generic-button
                (click)="deleteAnimals()"
                description="Delete animals"
                [alwaysShowText]="true"
                [buttonClass]="'btn-danger btn-danger-shadow'"
                [buttonText]="'Delete selected animals'"
                [disabled]="loading"
                [loading]="loading"
                [primaryIcon]="'fa-solid fa-trashcan'"/>
        </div>
        <hr/>
        <div class="d-flex flex-column gap-2">
            @for (animal of animals; track animal.id) {
                <app-animal-button [id]="animal.id"
                                   [clickable]="false"
                                   [selectableForAlteration]="false"
                                   [selectableForDeletion]="false"
                                   [standalone]="true"/>
            }
        </div>
    </div>
</div>